import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section id="solution" className="py-24 bg-stone-900 text-stone-50" data-id="element-1123">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1124">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1125">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-1126">
            The Solution
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-50 mb-6 max-w-3xl" data-id="element-1127">
            From email chaos to instant infrastructure
          </h2>

          <p className="text-lg text-stone-400 leading-relaxed mb-16 max-w-2xl" data-id="element-1128">
            BlockQuote replaces the entire manual quoting workflow with
            real-time infrastructure. What took days now takes seconds.
          </p>

          {/* Workflow Diagram */}
          <div className="border border-stone-700" data-id="element-1129">
            {/* Header */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1130">
              <div className="p-4 border-r border-stone-700" data-id="element-1131">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1132">
                  Before: Manual Process
                </p>
              </div>
              <div className="p-4" data-id="element-1133">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1134">
                  After: BlockQuote
                </p>
              </div>
            </div>

            {/* Step 1 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1135">
              <div className="p-6 border-r border-stone-700" data-id="element-1136">
                <div className="flex items-start gap-4" data-id="element-1137">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1138">
                    01
                  </span>
                  <div data-id="element-1139">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1140">
                      Email RFP received
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1141">
                      Unstructured data, manual parsing required
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1142">
                <div className="flex items-start gap-4" data-id="element-1143">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1144">
                    01
                  </span>
                  <div data-id="element-1145">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1146">
                      Instant quote request
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1147">
                      Structured input, real-time pricing
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1148">
              <div className="p-6 border-r border-stone-700" data-id="element-1149">
                <div className="flex items-start gap-4" data-id="element-1150">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1151">
                    02
                  </span>
                  <div data-id="element-1152">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1153">
                      Manual pricing lookup
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1154">
                      Check PMS, spreadsheets, rate cards
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1155">
                <div className="flex items-start gap-4" data-id="element-1156">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1157">
                    02
                  </span>
                  <div data-id="element-1158">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1159">
                      Auto-generated packages
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1160">
                      Good / Better / Best within policy
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1161">
              <div className="p-6 border-r border-stone-700" data-id="element-1162">
                <div className="flex items-start gap-4" data-id="element-1163">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1164">
                    03
                  </span>
                  <div data-id="element-1165">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1166">
                      48–72 hour response
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1167">
                      Back-and-forth negotiation via email
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1168">
                <div className="flex items-start gap-4" data-id="element-1169">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1170">
                    03
                  </span>
                  <div data-id="element-1171">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1172">
                      Instant hold + proposal
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1173">
                      Inventory secured, terms standardized
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="grid grid-cols-2" data-id="element-1174">
              <div className="p-6 border-r border-stone-700" data-id="element-1175">
                <div className="flex items-start gap-4" data-id="element-1176">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1177">
                    04
                  </span>
                  <div data-id="element-1178">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1179">
                      Lost groups + leakage
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1180">
                      No audit trail, margin captured by wholesalers
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1181">
                <div className="flex items-start gap-4" data-id="element-1182">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1183">
                    04
                  </span>
                  <div data-id="element-1184">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1185">
                      One-click contract
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1186">
                      Direct booking, full audit trail, zero leakage
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Summary row */}
            <div className="grid grid-cols-2 border-t border-stone-700" data-id="element-1187">
              <div className="p-6 border-r border-stone-700" data-id="element-1188">
                <p className="font-mono text-sm text-stone-500" data-id="element-1189">
                  Result:{' '}
                  <span className="text-stone-300" data-id="element-1190">
                    Days of delay, margin loss
                  </span>
                </p>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1191">
                <p className="font-mono text-sm text-stone-400" data-id="element-1192">
                  Result:{' '}
                  <span className="text-red-600" data-id="element-1193">
                    Seconds to quote, direct revenue
                  </span>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}